import { useTranslation } from 'react-i18next'
import './Loader.css'

/**
 * Fullscreen loading overlay shown while the initial `light` `GeometrySet` is
 * being fetched and tessellated. The underlying canvas keeps rendering (empty
 * clear color), so the spinner sits on top via a `position: absolute` overlay
 * with `pointer-events: none` — so future wheel events during the brief
 * loading window still pan/zoom the (as-yet empty) canvas rather than the
 * spinner eating them.
 *
 * The accessible label is localised via the `common` catalog
 * (`ui.loader.aria`). With no i18n provider mounted the i18next default
 * value keeps the original English label, so the component still renders
 * standalone.
 */
export function Loader() {
  const { t } = useTranslation('common')
  return (
    <div
      className="loader-overlay"
      role="status"
      aria-live="polite"
      aria-label={t('ui.loader.aria', { defaultValue: 'Loading map' })}
    >
      <div className="loader-spinner" />
    </div>
  )
}
